/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Gashaki 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Kigabiro": ["Birwa", "Butate", "Buzoza", "Kavumu", "Musekera", "Shanga"],
  "Kivumu": ["Burango", "Kamatete", "Makara", "Nyakariba", "Ruhehe"],
  "Mbwe": ["Budiho", "Gatete", "Kamato", "Kanzo", "Ngambi", "Raro"],
  "Muharuro": ["Bugabo", "Karuganda", "Kibinyogote", "Mucaca", "Murandi"]
};